import { Store } from "pullstate";
import { Allowance } from "../global/getAllowances";
import { Amount } from "../../types/amount";
import { Hash } from "viem";
import { TokenFlow } from "../../hooks/allowances/useTokensForApproval";
import { PermitType } from "../../utils/permitUtils";
import { TokenListByChain } from "store/global/GlobalStore";

export interface ApprovalsStoreSchema {
  initialAllowances: Array<Allowance>;
  currentAllowances: Array<Allowance>;
  tokensToApprove: Array<Allowance & { needed: Amount }>;
  requiredSignatures: Array<Hash>;
  tokensByFlow: {
    approve: Array<TokenFlow>;
    revoke: Array<TokenFlow>;
  };
  permitType: PermitType | undefined;
  approvalTarget: undefined | Hash;
  tokenLists: TokenListByChain | undefined;
}

export const ApprovalStore = new Store<ApprovalsStoreSchema>({
  initialAllowances: [],
  currentAllowances: [],
  tokensToApprove: [],
  requiredSignatures: [],
  tokensByFlow: {
    approve: [],
    revoke: [],
  },
  permitType: undefined,
  approvalTarget: undefined,
  tokenLists: undefined,
});
export const resetApprovalState = (): void => {
  ApprovalStore.update(s => {
    const stateToClear = [
      "initialAllowances",
      "currentAllowances",
      "tokensToApprove",
      "requiredSignatures",
      "tokensByFlow",
      "permitType",
      "approvalTarget",
      "tokenLists",
    ];

    return {
      ...s,
      ...stateToClear,
    };
  });
};
